import {Injectable} from '@angular/core';

import {Observable, Subject} from 'rxjs';

@Injectable()
export class ClockService {

  public clockConsumeTicks$: Observable<number>;
  protected clockConsumeTicksSource = new Subject<number>();
  private ticks = 0;

  constructor() {

    this.clockConsumeTicks$ = this.clockConsumeTicksSource.asObservable();

  }

  public consumeTicks(ticks: number) {

    this.ticks += ticks;

    this.clockConsumeTicksSource.next(ticks);

  }

  public getClock(): number {

    return this.ticks;

  }

}
